import {coreAPI} from "../../axios"
export const state = {
    hubConnection: process.env.NODE_ENV === 'production' ? window.GLOBAL_BACKEND_URL : process.env.VUE_APP_BACKEND_URL,
    notifications: [],
};
export const mutations = {
    SET_NOTIFICATIONS(state, data) {
        state.notifications = data;
    },
    REMOVE_NOTIFICATION(state, id) {
        let index = state.notifications.findIndex((x) => x.id == id);
        state.notifications.splice(index, 1);
    },
    OPEN_OPTIONS(state, data) {
        data.row.showDeleteOption = data.showDeleteOption;
    },
    SEEN_STATUS(state, data) {
        data.row.status = data.status;
    },
    ADD_NOTIFICATION(state, data) {
        state.notifications.unshift(data);
    },
    UPDATE_DATES(state) {
        function diffDate(date){
            const date1 = new Date(date);
            const date2 = new Date();
            const diffTime = Math.abs(date2 - date1);
            const diffDays = diffTime / (1000 * 60 * 60 * 24);
            const diffSecond = diffTime / 1000;
            const diffMin = diffTime / (1000 * 60);
            const diffHour = diffTime / (1000 * 60 * 60);
            if (diffDays >= 1) {
              if (diffDays > 365) {
                return `${Math.floor(diffDays / 365)} years ago`;
              }
              if (diffDays > 30) {
                let month = Math.trunc(diffDays / 30);
                return `${month} ${month > 1 ? "months" : "month"}  ago`;
              }
              return `${Math.trunc(diffDays)} days ago`;
            } else {
              if (diffHour >= 1) {
                return `${Math.trunc(diffHour)} hours ago`;
              }
              if (diffMin >= 1) {
                return `${Math.trunc(diffMin)} min ago`;
              }
              if (diffSecond >= 0) {
                return `${Math.trunc(diffSecond)} seconds ago`;
              }
              return "0 second ago";
            }
        }
        state.notifications.map((item) => {
            item.returnDate = diffDate(item.clientDate);
        })
        setTimeout(() => {
            this.myInterval = setInterval(() => {
                state.notifications.map((item) => {
                    item.returnDate = diffDate(item.clientDate);
                })
            }, 1000);
        }, 100);
    }
}

export const actions = {
    CreateNotif(context, data) {
        return coreAPI.post(`Notification/CreateNotification`, data);
    },
    GetMyNotif(context, data){
        return coreAPI.get("Notification/My");
    },
    SeenNotif(context, data) {
        coreAPI.put(`Notification/${data}`);
    },
    DeleteNotif({ commit }, data) {
        coreAPI.delete(`Notification/${data}`);
    },
    DeleteAllNotif() {
        coreAPI.delete(`Notification/Remove/All`);
    },
};